import * as React from 'react';

import {SourcesTablesWrapper} from './sources-tables-wrapper';

export function SetupSourcesPage() {
    return <SourcesTablesWrapper />;
}
